import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Search } from 'lucide-react';

const ResourceFilters = ({ filters, onFilterChange }) => {
  const types = [
    { value: 'all', label: 'All' },
    { value: 'blog', label: 'Blogs' },
    { value: 'case-study', label: 'Case Studies' },
    { value: 'rnd', label: 'R&D' },
    { value: 'soft-paper', label: 'Soft Papers' },
    { value: 'pdf', label: 'PDFs' }
  ];

  return (
    <div className="space-y-6">
      {/* Search Bar */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <Input
          type="text"
          placeholder="Search resources..."
          value={filters.search}
          onChange={(e) => onFilterChange({ ...filters, search: e.target.value })}
          className="pl-10 bg-white border-gray-300 text-gray-900 placeholder:text-gray-400 h-12 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
        />
      </div>

      {/* Type Filter Buttons */}
      <div className="flex flex-wrap gap-2">
        {types.map((type) => (
          <Button
            key={type.value}
            onClick={() => onFilterChange({ ...filters, type: type.value === 'all' ? '' : type.value })}
            variant={filters.type === type.value || (!filters.type && type.value === 'all') ? 'default' : 'outline'}
            className={`
              transition-all duration-300
              ${filters.type === type.value || (!filters.type && type.value === 'all')
                ? 'bg-gradient-to-r from-blue-500 to-sky-500 hover:from-sky-500 hover:to-blue-500 text-white border-transparent shadow-md'
                : 'bg-white hover:bg-blue-50 text-gray-700 border-gray-300 hover:border-blue-500'
              }
            `}
          >
            {type.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default ResourceFilters;
